import { render, staticRenderFns } from "./FormMentionGroup.vue?vue&type=template&id=95a70c7a"
import script from "./FormMentionGroup.vue?vue&type=script&lang=js"
export * from "./FormMentionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports